import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section2New = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  useEffect(() => {
    const categories = ["new_members"];

    // Calculate all totals in one go to batch the updates
    const updates = categories.reduce((acc, category) => {
      const male = Number(formState.migratedBelievers[category].male) || 0;
      const female = Number(formState.migratedBelievers[category].female) || 0;
      const total = male + female;

      if (total !== formState.migratedBelievers[category].total) {
        acc[category] = {
          ...formState.migratedBelievers[category],
          total
        };
      }
      return acc;
    }, {});

    // Only update if there are changes
    if (Object.keys(updates).length > 0) {
      handleChange("migratedBelievers", "all", updates);
    }
  }, [
    formState.migratedBelievers.new_members.male,
    formState.migratedBelievers.new_members.female
  ]);

  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ድምር</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ከሌሎች ቤተ አምነቶች ወደ ቤተ ክርሰቲያኒቷ የመጡ አማኞች ብዛት</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.migratedBelievers.new_members.male}
                  onValueChange={values => {
                    handleChange("migratedBelievers", "new_members", {
                      ...formState.migratedBelievers.new_members,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.migratedBelievers.new_members.female}
                  onValueChange={values => {
                    handleChange("migratedBelievers", "new_members", {
                      ...formState.migratedBelievers.new_members,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.migratedBelievers.new_members.total}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(2)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
